export default class uiUploader {
    constructor () {
        this.files = []
        this.options = {}
        this.activeUploads = 0
        this.uploadedFiles = 0
        this.abortUpload = () => {}
    }

    addFiles (files) { this.files = files }

    ajaxUpload = (file, headers) => {
        let that = this
        let {
            url, data, onProgress, onCompleted, onCompletedAll, onError, fileKey
        } = that.options
        data = data || {}

        this.activeUploads += 1
        file.active = true
        let xhr = new window.XMLHttpRequest()

        // To account for sites that may require CORS
        if (data.withCredentials === true) { xhr.withCredentials = true }

        const formData = new window.FormData()
        let body;
        xhr.open(that.options.method || 'POST', url);

        if (headers) {
            for (let headerKey in headers) {
                if (headers.hasOwnProperty(headerKey)) {
                    xhr.setRequestHeader(headerKey, headers[headerKey])
                }
            }
        }

        // Triggered when upload starts:
        xhr.upload.onloadstart = function () {}

        // Triggered many times during upload:
        xhr.upload.onprogress = function (event) {
            if (!event.lengthComputable) {
                return
            }
            // Update file size because it might be bigger than reported by
            // the fileSize:
            file.loaded = event.loaded
            file.humanSize = that.getHumanSize(event.loaded)
            if (typeof onProgress === 'function') { onProgress(file) }
        }

        // Triggered when upload is completed:
        xhr.onload = function () {
            that.activeUploads -= 1
            that.uploadedFiles += 1
            that.startUpload(that.options)
            if (typeof onCompleted === 'function') {
                onCompleted(file, xhr.responseText, xhr.status)
            }
            if (that.uploadedFiles === that.files.length) {
                that.uploadedFiles = 0
                if (typeof onCompletedAll === 'function') {
                    onCompletedAll(this.files)
                }
            }
        }

        // Triggered when upload fails:
        xhr.onerror = function (e) {
            if (typeof onError === 'function') { onError(e) }
        }

        // Abort the request before end
        this.abortUpload = function() {
            xhr.abort();
            if (typeof onError === 'function') { onError('request_aborted') }
            // reset activeUploads to allow start afresh on next request
            return this.activeUploads = 0
        };

        if (that.options.type == 'File') {
            body = file
        }
        else {
            // Append additional data if provided:
            if (data) {
                for (let prop in data) {
                    if (data.hasOwnProperty(prop)) {
                        formData.append(prop, data[prop])
                    }
                }
            }
            // Append file data:
            formData.append(fileKey ?? 'file', file, file.name)
            body = formData;
        }

        // Initiate upload:
        xhr.send(body)
        return xhr
    }

    getFiles () { return this.files }

    getHumanSize = (bytes) => {
        var sizes = ['n/a', 'bytes', 'KiB', 'MiB', 'GiB', 'TB', 'PB', 'EiB', 'ZiB', 'YiB'];
        var i = (bytes === 0) ? 0 : +Math.floor(Math.log(bytes) / Math.log(1024));
        return (bytes / Math.pow(1024, i)).toFixed(i ? 1 : 0) + ' ' + sizes[isNaN(bytes) ? 0 : i + 1];
    }

    removeAll () { this.files = [] }

    removeFile (file) { this.files.splice(this.files.indexOf(file), 1) }

    startUpload = (options) => {
        this.options = options

        //headers are not shared by requests
        let headers = options.headers || {}

        for (let file of this.files) {
            if (this.activeUploads == this.options.concurrency) {
                break
            }
            if (file.active) continue
            this.ajaxUpload(file, headers)
        }
    }
}